/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signupsempty1Inputs */

const en_signupsempty1 = /** @type {(inputs: Signupsempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No accounts created in this window.`)
};

const de_signupsempty1 = /** @type {(inputs: Signupsempty1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Konten in diesem Zeitraum erstellt.`)
};

/**
* | output |
* | --- |
* | "No accounts created in this window." |
*
* @param {Signupsempty1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const signupsempty1 = /** @type {((inputs?: Signupsempty1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signupsempty1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_signupsempty1(inputs)
	return de_signupsempty1(inputs)
});
export { signupsempty1 as "signupsEmpty" }